<template>
    <v-container fluid class="fixWidth">
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="12" sm="9" md="9">
                        <h3>{{parentData.title}}</h3>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-btn color="primary" dark @click="closeDialogAction">
                            Close
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col weight="500">
                        Description
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="9" md="9">
                        <div v-html="parentData.description"></div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
    props: [
        "parentData"
    ],
    methods: {
        closeDialogAction(){
            this.$emit('blogCommentReplyStatus');
        },
    },
}
</script>

<style scoped>
.fixWidth{
  width: auto;
}
</style>